// extracted by mini-css-extract-plugin
export default {"footerContainer":"styles_footerContainer__X8c3H","buttonContainer":"styles_buttonContainer__WC1ZL"};